import initialstate from '../../initialstate';
import {DELETE_SUB_SCOPE, GET_ASSIGNED_SCOPES} from '../../../actions/actiontypes';
import normalizeAssignedScopes from './normalizeAssignedScopes';
import { removeSubScopeById } from '../GroupScopes/removeSubScope';
import { HttpStatusCodes } from '../../../util/uiconstants';

export default function assignedScopesReducer(state = initialstate.groupAudit.assignedScopes, action) {
	switch (action.type) {
		case GET_ASSIGNED_SCOPES: {
			return normalizeAssignedScopes(action?.response);
		}
		case DELETE_SUB_SCOPE: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				return removeSubScopeById(state, action?.meta?.scopeId);
			}
			return state;
		}
		default:
			return state;
	}
}
